import { ChangeDetectionStrategy, Component, forwardRef, HostBinding, Input, OnInit, Optional } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'mtg-switcher-group',
  templateUrl: './switcher-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitcherGroupComponent),
      multi: true
    }
  ],
})
export class SwitcherGroupComponent implements OnInit, ControlValueAccessor {
  private onTouch: () => void;
  private onChange: (value) => void;
  private control: AbstractControl;

  @Input()
  formControl: FormControl;
  @Input()
  formControlName: string;
  @Input()
  reverse: boolean;
  value: any[] = [];
  @HostBinding('class.switcher-group')
  defaultClass = true;

  constructor(
    @Optional() private parentFormGroup: FormGroupDirective
  ) {
  }

  ngOnInit(): void {
    if (this.parentFormGroup) {
      this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
    } else {
      this.control = this.formControl;
    }
  }

  writeValue(obj: any): void {
    this.value = obj || [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  onItemChanged(value: any, checked: boolean): void {
    if (checked) {
      if (this.value.indexOf(value) < 0) {
        this.value.push(value);
      }
    } else {
      this.value.splice(this.value.indexOf(value), 1);
    }
    if (this.onTouch) {
      this.onTouch();
    }
    if (this.onChange) {
      this.onChange(this.value);
    }
  }
}
